"use client";

import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { SnackBarV2 } from "@website/ui/snackbar-v2";
import { AnimatedTelesales } from "@website/widget/telesales/animatedTelesale";
import { useTelesales } from "@website/widget/telesales/hooks";
import { TelesalesForm } from "@website/widget/telesales/telesales-form";
import { TelesalesPropertiesType } from "@website/widget/telesales/types";
export const Telesales = t0 => {
  const $ = _c(39);
  const {
    isPadding: t1,
    requestData,
    storageKey,
    reasons,
    onButtonClick,
    onSuccess,
    description,
    showAnimatedMobileButton,
    className
  } = t0;
  const isPadding = t1 === undefined ? false : t1;
  const {
    isOpenModal,
    setIsOpenModal,
    handleOpenModal,
    isSubmitBefore,
    onSubmitSuccess,
    onCloseSnackbar,
    snackbar
  } = useTelesales(storageKey, requestData.app);
  const t2 = showAnimatedMobileButton ? "max-md:hidden" : "";
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MaterialIcon className="absolute right-3 top-2 text-2xl" name="phone_enabled" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = `shadow-8 !fixed bottom-6 ${isPadding ? "max-lg:bottom-24 max-md:bottom-36" : ""} right-6 z-[12] gap-3 ${className ?? ""}`;
  let t5;
  if ($[1] !== handleOpenModal || $[2] !== onButtonClick) {
    t5 = () => {
      onButtonClick?.();
      handleOpenModal();
    };
    $[1] = handleOpenModal;
    $[2] = onButtonClick;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = <Button StartIcon={t3} children={"\u0631\u0632\u0631\u0648 \u062A\u0644\u0641\u0646\u06CC"} className={t4} color="secondary" onClick={t5} size="large" variant="round" />;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t2 || $[8] !== t6) {
    t7 = <div className={t2}>{t6}</div>;
    $[7] = t2;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== handleOpenModal || $[11] !== onButtonClick || $[12] !== showAnimatedMobileButton) {
    t8 = showAnimatedMobileButton && <div className="md:hidden"><AnimatedTelesales onClick={() => {
        onButtonClick?.();
        handleOpenModal();
      }} /></div>;
    $[10] = handleOpenModal;
    $[11] = onButtonClick;
    $[12] = showAnimatedMobileButton;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== setIsOpenModal) {
    t9 = () => setIsOpenModal(false);
    $[14] = setIsOpenModal;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== setIsOpenModal) {
    t10 = () => setIsOpenModal(false);
    $[16] = setIsOpenModal;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== description || $[19] !== isSubmitBefore || $[20] !== onSubmitSuccess || $[21] !== onSuccess || $[22] !== reasons || $[23] !== requestData || $[24] !== storageKey || $[25] !== t10) {
    t11 = <TelesalesForm description={description} isSubmitBefore={isSubmitBefore} onClose={t10} onSubmitSuccess={onSubmitSuccess} onSuccess={onSuccess} reasons={reasons} requestData={requestData} storageKey={storageKey} />;
    $[18] = description;
    $[19] = isSubmitBefore;
    $[20] = onSubmitSuccess;
    $[21] = onSuccess;
    $[22] = reasons;
    $[23] = requestData;
    $[24] = storageKey;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== isOpenModal || $[28] !== t11 || $[29] !== t9) {
    t12 = <Modal className="flex gap-6 lg:max-w-[448px]" headerStyle="text-headline-6 m-0" mobileHeight="auto" onClose={t9} open={isOpenModal} showCloseButton={true} title={"\u062B\u0628\u062A \u062F\u0631\u062E\u0648\u0627\u0633\u062A \u0631\u0632\u0631\u0648 \u062A\u0644\u0641\u0646\u06CC"}>{t11}</Modal>;
    $[27] = isOpenModal;
    $[28] = t11;
    $[29] = t9;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== onCloseSnackbar || $[32] !== snackbar) {
    t13 = <SnackBarV2 {...snackbar} onClose={onCloseSnackbar} />;
    $[31] = onCloseSnackbar;
    $[32] = snackbar;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t12 || $[35] !== t13 || $[36] !== t7 || $[37] !== t8) {
    t14 = <>{t7}{t8}{t12}{t13}</>;
    $[34] = t12;
    $[35] = t13;
    $[36] = t7;
    $[37] = t8;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
};